'use strict';

(function ($, Drupal) {
  var INCREMENTING_NUMBER_SELECTOR = '.incrementing-number-list .incrementing-number';
  var animationsExecuted = new Set(); // To track which elements have been animated

  function incrementNumbers($container) {
    var $numbers = $container ? $container.find('.number') : $(INCREMENTING_NUMBER_SELECTOR + ' .number');

    $numbers.each(function () {
      var $elem = $(this);
      // Check if this element has already been animated
      if (animationsExecuted.has($elem[0])) {
        return;
      }

      var initialValue = $elem.attr('data-value');
      var value = parseFloat(initialValue);

      if (isNaN(value)) {
        return;
      }

      $({percentage: 0}).stop(true).animate({percentage: value}, {
        duration : 2000,
        easing: "swing",
        step: function () {
          var percentageVal = Math.round(this.percentage);
          $elem.text(percentageVal);
        }
      }).promise().done(function () {
        $elem.text(initialValue);
      });

      // Mark this element as animated
      animationsExecuted.add($elem[0]);
    });
  }

  // Initialize AOS with callback
  if (typeof AOS !== 'undefined') {
    AOS.init({
      once: false, // Allow multiple animations
      offset: 120,
      duration: 1000,
    });
  }

  // Handle animation when elements are visible
  $('.incrementing-number-list').each(function() {
    var $container = $(this);
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          incrementNumbers($container);
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe($container[0]);
  });

  // Keep AOS event as backup
  document.addEventListener('aos:in:incrementing-number-run-numbers', function (event) {
    var $container = $(event.target);
    incrementNumbers($container);
  });

  // Reset animations when changing page or section
  $(document).on('page:loaded section:loaded', function() {
    animationsExecuted.clear(); // Clear animation registry
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  });

})(jQuery, Drupal);
